import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  tableTitle: {
    paddingBottom: 16,
    paddingTop: 16,
    marginTop: -16,
    position: "sticky",
    top: 0,
    backgroundColor: theme.props.backgroundSecondary,
    zIndex: 10,
  },
  spinner: {
    position: "relative",
    left: "calc(50% - 20px)",
  },
}));

export default useStyle;
